// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export type CollateralKeyArgs = {
  partyA: string;
  partyB: string;
  operator: string;
  id: string;
};

export type CollateralKey = string & { __type: 'collateralKey' };

export const getCollateralKey = ({
  partyA,
  partyB,
  operator,
  id,
}: CollateralKeyArgs): CollateralKey => {
  return `ID_${id};OPERATOR_${operator};PARTY_A_${partyA};PARTY_B_${partyB}` as CollateralKey;
};
